<div *ngIf="diskProfile">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>album</mat-icon>
      {{
        diskProfile.id ? "Disk Profile - " + diskProfile.name : "Create new Disk Profile"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid"
      >
        <mat-icon>{{ diskProfile.id ? "save" : "add" }}</mat-icon>
        {{ diskProfile.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="diskProfile.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">Disk Profile Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [(companyId)]="diskProfile.companyId" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="code"
                [model]="code"
                label="Code"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #code="ngModel"
                [(ngModel)]="diskProfile.code"
                required
                maxlength="10"
                id="code"
                name="code"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="diskProfile.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>Description</th>
            <td>
              <textarea
                [(ngModel)]="diskProfile.description"
                maxlength="50"
                id="description"
                name="description"
                style="min-width: 350px; min-height: 100px;"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th [ngClass]="diskProfile.active !== 'Y' ? 'CRITICAL' : ''">
              <micro-valid-label
                for="active"
                label="Active"
              ></micro-valid-label>
            </th>
            <td>
              <input type="checkbox" [checked]="diskProfile.active === 'Y'" (change)="onCheckboxChange('active', $event)" id="active" name="active">
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="templateId"
                [model]="templateId"
                label="Template ID"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #templateId="ngModel"
                [(ngModel)]="diskProfile.templateId"
                required
                maxlength="32"
                id="templateId"
                name="templateId"
              />
            </td>
          </tr>
          <tr>
            <th>Hosting Platform</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbHostingPlatform"
                [(id)]="diskProfile.platformId"
                [defaultOption]="selectedHostingPlatform"
                placeholder="Select hosting platform"
                (objectChange)="onHostingPlatformChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>OS Version</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbOsVersions"
                [(id)]="diskProfile.osVersionId"
                [defaultOption]="selectedOsVersion"
                placeholder="Select OS version"
                (objectChange)="onOsVersionChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="osDefaultDiskSize"
                [model]="osDefaultDiskSize"
                label="OS Default Disk Size"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #osDefaultDiskSize="ngModel"
                [(ngModel)]="diskProfile.osDefaultDiskSize"
                required
                type="number"
                id="osDefaultDiskSize"
                name="osDefaultDiskSize"
                min="0"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="minGB"
                [model]="minGB"
                label="Min GB "
              ></micro-valid-label>
            </th>
            <td>
              <input
                #minGB="ngModel"
                [(ngModel)]="diskProfile.minGB"
                required
                type="number"
                id="minGB"
                name="minGB"
                min="0"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="maxGB"
                [model]="maxGB"
                label="Max GB"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #maxGB="ngModel"
                [(ngModel)]="diskProfile.maxGB"
                required
                type="number"
                id="maxGB"
                name="maxGB"
                min="0"
              />
            </td>
          </tr>
          <tr>
            <th>
              OS Disk Type
            </th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbDiskTypes"
                [(id)]="diskProfile.osDiskTypeId"
                [defaultOption]="selectedOsDiskType"
                placeholder="Select OS Disk Type"
                (objectChange)="onOsDiskTypeChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>
              OS Mount
            </th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/CmdbMountPoints"
                [(id)]="diskProfile.osMountId"
                [defaultOption]="selectedOsMount"
                placeholder="Select OS Mount"
                (objectChange)="onOsMountChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="reason"
                [model]="reason"
                label="Reason"
              ></micro-valid-label>
            </th>
            <td>
              <textarea
                #reason="ngModel"
                [(ngModel)]="diskProfile.reason"
                maxlength="200"
                id="reason"
                name="reason"
                style="min-width: 350px; min-height: 100px;"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="maxAdditionalDisks"
                [model]="maxAdditionalDisks"
                label="Max Additional Disks"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #maxAdditionalDisks="ngModel"
                [(ngModel)]="diskProfile.maxAdditionalDisks"
                required
                type="number"
                id="maxAdditionalDisks"
                name="maxAdditionalDisks"
                min="0"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="maxTotalDisks"
                [model]="maxTotalDisks"
                label="Max Total Disks"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #maxTotalDisks="ngModel"
                [(ngModel)]="diskProfile.maxTotalDisks"
                required
                type="number"
                id="maxTotalDisks"
                name="maxTotalDisks"
                min="0"
              />
            </td>
          </tr>
          <tr>
            <th>Storage Tier</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/CmdbStorageTiers"
                [(id)]="diskProfile.storageTierId"
                [defaultOption]="selectedStorageTier"
                placeholder="Select Storage Tier"
                (objectChange)="onStorageTierChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th [ngClass]="diskProfile.encryptionMandatory !== 'Y' ? 'WARNING' : ''">
              <micro-valid-label
                for="encryptionMandatory"
                label="Encryption Mandatory"
              ></micro-valid-label>
            </th>
            <td>
              <input type="checkbox" [checked]="diskProfile.encryptionMandatory === 'Y'" (change)="onCheckboxChange('encryptionMandatory', $event)" id="encryptionMandatory" name="encryptionMandatory">
            </td>
          </tr>
          <tr>
            <th [ngClass]="diskProfile.engineerAdd !== 'Y' ? 'WARNING' : ''">
              <micro-valid-label
                for="engineerAdd"
                label="Engineer Add"
              ></micro-valid-label>
            </th>
            <td>
              <input type="checkbox" [checked]="diskProfile.engineerAdd === 'Y'" (change)="onCheckboxChange('engineerAdd', $event)" id="engineerAdd" name="engineerAdd">
            </td>
          </tr>
          <tr>
            <th [ngClass]="diskProfile.engineerResize !== 'Y' ? 'WARNING' : ''">
              <micro-valid-label
                for="engineerResize"
                label="Engineer Resize"
              ></micro-valid-label>
            </th>
            <td>
              <input type="checkbox" [checked]="diskProfile.engineerResize === 'Y'" (change)="onCheckboxChange('engineerResize', $event)" id="engineerResize" name="engineerResize">
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="notes"
                [model]="notes"
                label="Notes"
              ></micro-valid-label>
            </th>
            <td>
              <textarea
                #notes="ngModel"
                [(ngModel)]="diskProfile.notes"
                maxlength="500"
                id="notes"
                name="notes"
                style="min-width: 350px; min-height: 100px;"
              ></textarea>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
